import React, { createContext, Dispatch, SetStateAction, useContext, useState } from 'react';
export const MapClickResultsOpeningContext = createContext({} as MapClickResultsOpeningContext);

export interface MapClickResultsOpeningContext {
  setOpen: Dispatch<SetStateAction<boolean>>;
  open: boolean;
  atvkId?: string;
  setAtvkId: Dispatch<SetStateAction<string>>;
}
export interface MapClickResultsOpeningContextProviderProps {
  children: React.ReactNode;
}

export const useMapClickResultsOpening = () => {
  return useContext(MapClickResultsOpeningContext);
};

const MapClickResultsOpeningContextProvider = ({ children }: MapClickResultsOpeningContextProviderProps) => {
  const [open, setOpen] = useState(false);
  const [atvkId, setAtvkId] = useState<string>('');

  return (
    <MapClickResultsOpeningContext.Provider value={{ open, setOpen, atvkId, setAtvkId }}>
      {children}
    </MapClickResultsOpeningContext.Provider>
  );
};

export default MapClickResultsOpeningContextProvider;
